import { createContext } from 'react';

const CommonContext = createContext(void 0);

CommonContext.displayName = 'context(Common)';

export default CommonContext;